import { IStackTokens, IDropdownOption, ITag } from "office-ui-fabric-react";
import UPSIcon from "../../images/UPS-icon.svg";
import TransformerIcon from "../../images/transformer-icon.svg";
import HTPanelIcon from "../../images/Ht-panel-icon.svg";
import SMPSIcon from "../../images/SMPS-icon.svg";
import PACIcon from "../../images/PAC-icon.svg";
import CooledIcon from "../../images/Cooled-icon.svg";
import IDCIcon from "../../images/IDC-icon.svg";
import DGSetIcon from "../../images/DG-Set-icon.svg";
import TempRhIcon from "../../images/temp-humidity.svg";
import PowerUtilizationIcon from "../../images/power-utilization.svg";
import AccessLogsIcon from "../../images/logs-icon.svg";
import UpTimeIcon from "../../images/up-time.svg";
import CCTVIcon from "../../images/cctv-icon.svg";
import ServiceTicketsIcon from "../../images/service-tickets-icon.svg";
import IncidentsIcon from "../../images/incidents-icon.svg";
import RemoteHandServiceIcon from "../../images/remote-hand-services-icon.svg";
import SlaMatrixIcon from "../../images/sla-icon.svg";
import AuthorizedContactsIcon from "../../images/contacts-icon.svg";
import ServiceDetailsIcon from "../../images/service-detail-icon.svg";
import PreviousMeetingsIcon from "../../images/meetings-icon.svg";
import AssignEMIcon from "../../images/assign-escalation-matrix-icon.svg";
import ActivityUpdatesIcon from "../../images/activity-update.svg";
import CRSIcon from "../../images/customer-rack-status.svg";
import PMScheduleIcon from "../../images/preventive-maintenance-schedule.svg";
import MiscellaneousFilesIcon from "../../images/miscellaneous-files.svg";
import { IFileUploadConfig } from "../../vm";

//local
// export const API_URL = "http://localhost:7171/";
// export const STORAGE_API_URL = "http://localhost:7474/";

//dev
// export const API_URL = "http://3.111.140.128:8096/";
// export const STORAGE_API_URL = "http://3.111.140.128:8095/";

// hyd dev
// export const API_URL = "http://10.21.10.71:8001/";
// export const STORAGE_API_URL = "http://10.21.10.71:7474/";

//  bkc server
export const API_URL = "https://devsttmorapi.contenterra.in/";
export const STORAGE_API_URL = "https://devsttstorageapi.contenterra.in/";

// //  delhi server
// export const API_URL = 'https://10.18.40.66:8009/';
// export const STORAGE_API_URL = 'https://10.18.40.66:8010/'; // this should be primary server

export const childrenGap: IStackTokens = { childrenGap: 16 };
export const childrenGap8: IStackTokens = { childrenGap: 8 };

export const USER_ROLES: IDropdownOption[] = [
  { key: 0, text: "Admin" },
  { key: 1, text: "Datacenter Admin" },
];

export const ADMIN_ROLES: IDropdownOption[] = [
  { key: 0, text: "Super Admin" },
  { key: 2, text: "CEM" },
  { key: 3, text: "Admin" },
  { key: 4, text: "CEM Admin" },
  { key: 5, text: "MIS" },
];

export const EMATRIX_TYPES: IDropdownOption[] = [
  { key: "idc-shift-manager", text: "IDC Shift Manager" },
  { key: "sr-shift-engineer", text: "Sr. Shift Engineer" },
  { key: "support-desk-lead", text: "Support Desk Lead" },
  { key: "assistant-shift-manager", text: "Assistant Shift Manager" },
  { key: "assistant-manager", text: "Assistant Manager" },
  { key: "dc-manager", text: "DC Manager" },
  { key: "manager", text: "Manager" },
  { key: "senior-manager", text: "Senior Manager" },
  { key: "assistant-gen-manager", text: "Assistant Gen. Manager" },
  { key: "director", text: "Director" },
  { key: "associate-director", text: "Associate Director" },
  { key: "senior-director", text: "Senior Director" },
  { key: "associate-vice-president", text: "Associate Vice President" },
  { key: "vice-president", text: "Vice President" },
  { key: "senior-vice-president", text: "Senior Vice President" },

  // { key: "manager-service-desk", text: "Manager Service Desk" },
  // { key: "regional-manager", text: "Regional Manager" },
  // { key: "director-customer-experience", text: "Director Customer Experience" },
  // { key: "`vp-customer-experience`", text: "VP Customer Experience" },
];
export const EMATRIX_ROLES: IDropdownOption[] = [
  {
    key: "customer-experience-team",
    text: "Customer Experience Management",
  },
  { key: "operation-team", text: "Operation Team" },
  { key: "sales-team", text: "Sales Team" },
];

export const EMATRIX_LEVELS: IDropdownOption[] = [
  {
    key: "l1",
    text: "L1",
  },
  { key: "l2", text: "L2" },
  { key: "l3", text: "L3" },
  { key: "l4", text: "L4" },
];

export const EMATRIX_LEVELS_DICT: { [key: string]: string } = {
  l1: "L1",
  l2: "L2",
  l3: "L3",
  l4: "L4",
};

export const TRANSFORMER_COLOUR: IDropdownOption[] = [
  { key: "blue", text: "Blue" },
  { key: "pink", text: "Pink" },
];

export const TRANSFORMER_OIL_LEVEL: IDropdownOption[] = [
  { key: "1/4", text: "1/4" },
  { key: "1/2", text: "1/2" },
  { key: "3/4", text: "3/4" },
];

export const SC_SYSTEM_TYPE: IDropdownOption[] = [
  { key: "gallagher", text: "Gallagher" },
  { key: "ganesh-computer", text: "Ganesh Computer" },
  { key: "schneider", text: "Schneider" },
  { key: "delta", text: "Delta" },
  { key: "siemens", text: "Siemens" },
  { key: "tridium", text: "Tridium" },
  { key: "service-now", text: "Service Now" },
  { key: "ebi", text: "Ebi" },
];

export const SC_CONNECTION_TYPE: IDropdownOption[] = [
  { key: "mssql", text: "MSSQL" },
  { key: "pg", text: "PG" },
  { key: "rest-api", text: "Rest Api" },
  { key: "web-service", text: "Web Service" },
  { key: "snmp", text: "SNMP" },
  { key: "ms-access", text: "MS Access" },
];

export const SC_CONNECTION_TYPE_DROPDOWN_DICT: {
  [key: string]: IDropdownOption[];
} = {
  gallagher: [{ key: "mssql", text: "MSSQL" }],
  schneider: [{ key: "mssql", text: "MSSQL" }],
  delta: [
    { key: "pg", text: "PG" },
    { key: "snmp", text: "SNMP" },
  ],
  tridium: [{ key: "web-service", text: "Web Service" }],
  siemens: [{ key: "rest-api", text: "Rest Api" }],
  "ganesh-computer": [{ key: "ms-access", text: "MS Access" }],
  "service-now": [{ key: "web-service", text: "Web Service" }],
  ebi: [{ key: "excel", text: "Excel" }],
};

export const SC_SENSOR_TYPE: IDropdownOption[] = [
  { key: "pdu", text: "PDU" },
  { key: "temp-rh", text: "TEMP & RH" },
];

export const SC_SERVICE_NOW_URL_TYPE: IDropdownOption[] = [
  { key: "tickets", text: "Tickets" },
  { key: "authorized-contacts", text: "Authorized Contacts" },
];

export const DATABASE_TABLE_TYPE: IDropdownOption[] = [
  { key: "dedicated", text: "Dedicated" },
  { key: "rack-wise", text: "Rack Wise" },
];

export const DC_STATUS_DROPDOWN: IDropdownOption[] = [
  { key: 10, text: "All Report Status" },
  { key: 0, text: "Submission awaiting from Ops Team" },
  { key: 1, text: "Submitted by Ops Team" },
  { key: 2, text: "Approved by DC Manager" },
  { key: -2, text: "Rejected by DC Manager" },
  { key: 3, text: "Approved by MIS" },
  { key: -3, text: "Rejected by MIS" },
  { key: 4, text: "Approved by CEM" },
  { key: -4, text: "Rejected by CEM" },
  { key: 5, text: "Send Email to Customer" },
];

export const MEETINGS_STATUS_DROPDOWN: IDropdownOption[] = [
  { key: "all", text: "All" },
  // { key: "pending", text: "Pending" },
  { key: "open", text: "Open" },
  { key: "wip", text: "Work In Progress" },
  { key: "closed", text: "Closed" },
];

export const MEETINGS_LOCATION_DICT: { [Key: string]: string } = {
  "stt-office": "STT Office",
  "customer-office": "Customer Office",
  virtual: "Virtual",
};

export const MEETINGS_OWNER_DICT: { [Key: string]: string } = {
  stt: "STT",
  customer: "Customer",
  // "both": "STT & Customer"
};

export const MEETINGS_STATUS_DICT: { [Key: string]: string } = {
  open: "Open",
  // pending: "Pending",
  "under-observation": "Under Observation",
  wip: `Work In Progress`,
  closed: "Closed",
};

export const MEETINGS_LEGEND_DICT: { [Key: string]: string } = {
  action: "Action",
  information: "Information",
  decision: "Decision",
};

export const DC_STATUS_DICT: { [Key: number]: string } = {
  0: "Submission awaiting from Ops Team",
  1: `Submitted by Ops Team`,
  2: "Approved by DC Manager",
  3: "Approved by MIS",
  4: "Approved by CEM",
  5: "Send Email to Customer",
  "-2": "Rejected by DC Manager",
  "-3": "Rejected by MIS",
  "-4": "Rejected by CEM",
};

export const ADMIN_ROLES_DIC: { [Key: number]: string } = {
  0: "Super Admin",
  1: "Datacenter Manager",
  2: "CEM",
  3: "Admin",
  4: "CEM Admin",
  5: "MIS",
};

export const ROLES_DIC: { [Key: number]: string } = {
  0: "Shift Manager",
  1: "Shift Operator",
};

export const EMATRIX_DIC: { [Key: string]: string } = {
  "idc-shift-manager": "IDC Shift Manager",
  "sr-shift-engineer": "Sr. Shift Engineer",
  "support-desk-lead": "Support Desk Lead",
  "assistant-shift-manager": "Assistant Shift Manager",
  "assistant-manager": "Assistant Manager",
  "dc-manager": "DC Manager",
  manager: "Manager",
  "senior-manager": "Senior Manager",
  "assistant-gen-manager": "Assistant Gen. Manager",
  director: "Director",
  "associate-director": "Associate Director",
  "senior-director": "Senior Director",
  "associate-vice-president": "Associate Vice President",
  "vice-president": "Vice President",
  "senior-vice-president": "Senior Vice President",

  // "manager-service-desk": "Manager Service Desk",
  // "director-customer-experience": "Director Customer Experience",
  // "vp-customer-experience": "VP Customer Experience",
  // "regional-manager": "Regional Manager",
};
export const EMATRIX_ROLE_DIC: { [Key: string]: string } = {
  "sales-team": "Sales Team",
  "operation-team": "Operations Team",
  "customer-experience-team": "Customer Experience Management",
};

export const SC_SYSTEM_TYPE_DIC: { [Key: string]: string } = {
  gallagher: "Gallagher",
  schneider: "Schneider",
  delta: "Delta",
  siemens: "Siemens",
  tridium: "Tridium",
  "ganesh-computer": "Ganesh Computer",
  "service-now": "Service Now",
  ebi: "Ebi",
};

export const SC_CONNECTION_TYPE_DIC: { [Key: string]: string } = {
  mssql: "MSSQL",
  pg: "PG",
  "rest-api": "Rest Api",
  "web-service": "Web Service",
  snmp: "SNMP",
  "ms-access": "MS Access",
  excel: "Excel",
};

export const ACCESS_LOG_DATE_FORMAT: { [Key: string]: string } = {
  "MM/DD/YYYY hh:mm:ss A": "MM/DD/YYYY - 12 Hours",
  "MM/DD/YYYY hh:mm:ss": "MM/DD/YYYY - 24 Hours",
  "DD/MM/YYYY hh:mm:ss A": "DD/MM/YYYY - 12 Hours",
  "DD/MM/YYYY hh:mm:ss": "DD/MM/YYYY - 24 Hours",
};

export const EMAIL_REGEX = /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i;

export const INFRASTRUCTURE_TYPES = [
  {
    value: "ups",
    label: "UPS",
    key: "ups",
    imageUrl: UPSIcon,
    width: 34,
    height: 60,
  },
  {
    value: "transformer",
    label: "Transformer",
    key: "transformer",
    imageUrl: TransformerIcon,
    width: 55,
    height: 70,
  },
  {
    value: "ht-panel",
    label: "Ht-Panel",
    key: "ht",
    imageUrl: HTPanelIcon,
    width: 46,
    height: 64,
  },
  {
    value: "smps",
    label: "SMPS",
    key: "smps",
    imageUrl: SMPSIcon,
    width: 66,
    height: 66,
  },
  {
    value: "pac",
    label: "PAC/PAHU",
    key: "pac",
    imageUrl: PACIcon,
    width: 64,
    height: 64,
  },
  {
    value: "cooled-chiller",
    label: "Cooled Chiller",
    key: "cooled-chiller",
    imageUrl: CooledIcon,
    width: 65,
    height: 69,
  },
  {
    value: "idc-temperature",
    label: "IDC Temperature",
    key: "idc",
    imageUrl: IDCIcon,
    width: 25,
    height: 58,
  },
  {
    value: "dg-set",
    label: "DG-Set",
    key: "dg",
    imageUrl: DGSetIcon,
    width: 68,
    height: 68,
  },
];
export const INFRASTRUCTURE_AUTOMATION_TYPES = [
  {
    value: "temp-rh",
    label: "Temperature & Humidity",
    key: "temp-rh",
    imageUrl: TempRhIcon,
    width: 53,
    height: 69,
  },
  {
    value: "power-utilization",
    label: "Power Utilization",
    key: "power-utilization",
    imageUrl: PowerUtilizationIcon,
    width: 61,
    height: 61,
  },
];

export const CUSTOMER_CARD_TYPES = [
  {
    value: "access-logs",
    label: "Access Logs",
    key: "access-logs",
    imageUrl: AccessLogsIcon,
    width: 74,
    height: 57,
  },
  {
    value: "temperature-humidity",
    label: "Temperature & Humidity",
    key: "temperature-humidity",
    imageUrl: TempRhIcon,
    width: 53,
    height: 69,
  },
  {
    value: "power-utilization",
    label: "Power Utilization",
    key: "power-utilization",
    imageUrl: PowerUtilizationIcon,
    width: 61,
    height: 61,
  },
  {
    value: "cctv-image",
    label: "CCTV Image",
    key: "cctv-image",
    imageUrl: CCTVIcon,
    width: 74,
    height: 63,
  },
  {
    value: "up-time",
    label: "Up-Time",
    key: "up-time",
    imageUrl: UpTimeIcon,
    width: 59,
    height: 68,
  },
  {
    value: "access-permission-and-material-movement",
    label: "Access Permission & Material Movement",
    key: "access-permission-and-material-movement",
    // value: "service-tickets",
    // label: "Service Tickets",
    // key: "service-tickets",
    imageUrl: ServiceTicketsIcon,
    width: 50,
    height: 71,
  },
  {
    value: "complaints-and-other-requests",
    label: "Complaints & Other Requests",
    key: "complaints-and-other-requests",
    // value: "incidents",
    // label: "Incidents",
    // key: "incidents",
    imageUrl: IncidentsIcon,
    width: 69,
    height: 63,
  },
  {
    value: "remote-hand-services",
    label: "Remote Hand Services",
    key: "remote-hand-services",
    imageUrl: RemoteHandServiceIcon,
    width: 64,
    height: 64,
  },
  {
    value: "sla-matrixes-config",
    label: "SLA Matrix",
    key: "sla-matrixes-config",
    imageUrl: SlaMatrixIcon,
    width: 51,
    height: 62,
  },
  {
    value: "authorized-contacts",
    label: "Authorized Contacts",
    key: "authorized-contacts",
    imageUrl: AuthorizedContactsIcon,
    width: 58,
    height: 58,
  },
  {
    value: "service-details",
    label: "Service Details",
    key: "service-details",
    imageUrl: ServiceDetailsIcon,
    width: 62,
    height: 62,
  },
  {
    value: "customer-meetings",
    label: "Customer Meetings",
    key: "customer-meetings",
    // value: "previous-meetings",
    // label: "Previous Meetings",
    // key: "previous-meetings",
    imageUrl: PreviousMeetingsIcon,
    width: 74,
    height: 71,
  },
  {
    value: "assign-escalation-matrix",
    label: "Assign Escalation Matrix",
    key: "assign-escalation-matrix",
    imageUrl: AssignEMIcon,
    width: 74,
    height: 72,
  },
  {
    value: "activity-updates",
    label: "Activity Updates",
    key: "activity-updates",
    imageUrl: ActivityUpdatesIcon,
    width: 62,
    height: 59,
  },
  {
    value: "customer-rack-status",
    label: "Customer Rack Status",
    key: "customer-rack-status",
    imageUrl: CRSIcon,
    width: 51,
    height: 51,
  },
  {
    value: "preventive-maintenence-schedule",
    label: "Preventive Maintenence Schedule",
    key: "preventive-maintenence-schedule",
    imageUrl: PMScheduleIcon,
    width: 55,
    height: 55,
  },
  {
    value: "others-files",
    label: "Others Files",
    key: "others-files",
    imageUrl: MiscellaneousFilesIcon,
    width: 53,
    height: 55,
  },
];

export const CUSTOMER_CARD_TYPES_DROPDOWN: IDropdownOption[] = [
  { key: "access-logs", text: "Access Logs" },
  {
    key: "temp-and-rh",
    text: "Temperature & Humidity",
  },
  {
    key: "pdu",
    text: "Power Utilization",
  },
  // {
  //   key: 'cctv-image',
  //   text: 'CCTV Image',
  // },
  // {
  //   key: 'up-time',
  //   text: 'Up-Time',
  // },
];
export const PDU_TYPE_DROPDOWN: IDropdownOption[] = [
  { key: "rackwise", text: "Rack Wise" },
  { key: "dedicated", text: "Dedicated" },
];

export const ACCESS_LOG_TYPE_DROPDOWN: IDropdownOption[] = [
  { key: "card-holders", text: "Card Holders" },
  { key: "acs-details", text: "ACS Details" },
];

export const ASSIGNED_ESCALATION_MATRIX_TYPE: IDropdownOption[] = [
  { key: "customer-experience-team", text: "Customer Experience Management" },
  { key: "sales-team", text: "Sales Team" },
];

export const ASSIGNED_ESCALATION_MATRIX_TYPE_DICT: { [Key: string]: string } = {
  "customer-experience-team": "Customer Experience Team",
  "sales-team": "Sales Team",
};

export const AUTHORIZED_CONTACTS_SOURCE_DICT: { [Key: string]: string } = {
  snow: "SNOW",
  manual: "Manual",
};

export const INFRASTRUCTURE_TAGS: ITag[] = [
  { key: "ups", name: "UPS" },
  { key: "transformer", name: "Transformer" },
  { key: "ht", name: "HT Panel" },
  { key: "smps", name: "SMPS" },
  { key: "pac", name: "PAC/PAHU" },
  { key: "air-cooled-chiller", name: "Cooled Chiller" },
  { key: "idc", name: "IDC Temperature" },
  { key: "dg", name: "DG Set" },
];

export const INFRA_DICT: { [Key: string]: string } = {
  ups: "UPS",
  transformer: "Transformer",
  ht: "HT Panel",
  smps: "SMPS",
  pac: "PAC/PAHU",
  "air-cooled-chiller": "Cooled Chiller",
  idc: "IDC Temperature",
  dg: "DG Set",
};

export const READ_AT_TIME_FORMAT = "HH:mm";
export const CUSTOMER_CARD_HOLDER_TIME_FORMAT = "DD-MM-YYYY HH:mm:ss";

export const ODD_SHIFT = [
  "01:00",
  // '03:00',
  "05:00",
  // '07:00',
  "09:00",
  // '11:00',
  "13:00",
  // '15:00',
  "17:00",
  // '19:00',
  "21:00",
  // '23:00',
];
export const EVEN_SHIFT = [
  "00:00",
  // "02:00",
  "04:00",
  // "06:00",
  "08:00",
  // "10:00",
  "12:00",
  // "14:00",
  "16:00",
  // "18:00",
  "20:00",
  // "22:00",
];
export const ALL_SHIFT = [
  "00:00",
  "01:00",
  "02:00",
  "03:00",
  "04:00",
  "05:00",
  "06:00",
  "07:00",
  "08:00",
  "09:00",
  "10:00",
  "11:00",
  "12:00",
  "13:00",
  "14:00",
  "15:00",
  "16:00",
  "17:00",
  "18:00",
  "19:00",
  "20:00",
  "21:00",
  "22:00",
  "23:00",
];

export const UPS_STATUS: any = {
  submitted: "Submitted",
  approved: "Approved",
  rejected: "Rejected",
};

export const DayPickerStrings = {
  months: [
    "January",
    "February",
    "March",
    "April",
    "May",
    "June",
    "July",
    "August",
    "September",
    "October",
    "November",
    "December",
  ],
  shortMonths: [
    "Jan",
    "Feb",
    "Mar",
    "Apr",
    "May",
    "Jun",
    "Jul",
    "Aug",
    "Sep",
    "Oct",
    "Nov",
    "Dec",
  ],
  days: [
    "Sunday",
    "Monday",
    "Tuesday",
    "Wednesday",
    "Thursday",
    "Friday",
    "Saturday",
  ],
  shortDays: ["S", "M", "T", "W", "T", "F", "S"],
  goToToday: "Go to today",
  weekNumberFormatString: "Week number {0}",
  prevMonthAriaLabel: "Previous month",
  nextMonthAriaLabel: "Next month",
  prevYearAriaLabel: "Previous year",
  nextYearAriaLabel: "Next year",
  prevYearRangeAriaLabel: "Previous year range",
  nextYearRangeAriaLabel: "Next year range",
  closeButtonAriaLabel: "Close",
  monthPickerHeaderAriaLabel: "{0}, select to change the year",
  yearPickerHeaderAriaLabel: "{0}, select to change the month",
};

// <------------------- File Upload Modules ---------------------->
export const enum FILE_UPLOAD_MODULES {
  CCTV_IMAGE = "cctv-image",
  MANAGE_REPORT_APPROVAL = "manage-report-approval",
  MISCELLANEOUS_FILES = "miscellaneous-files",
  MISCELLANEOUS_FILES_POWER = "miscellaneous-files-power",
  MANAGE_PM_SEND_EMAIL = "manage-pm-send-email",
  MANAGE_SLA_NOTES = "manage-sla-notes",
  MANAGE_IMPORT_DIALOG = "manage-import-dialog",
  MANAGE_PM_SCHEDULE = "manage-pm-schedule",
}

// <------------------- File Upload Config ---------------------->
export const FILE_UPLOAD_CONFIG: Record<string, IFileUploadConfig> = {
  [FILE_UPLOAD_MODULES.CCTV_IMAGE]: {
    acceptedFileTypes:
      "image/x-png, image/gif, image/jpeg, image/jpg, image/png",
    fileTypeDescription: "Image files (JPG, JPEG, PNG, GIF)",
    hintText: "Supported file types: JPG, JPEG, PNG, GIF",
  },
  [FILE_UPLOAD_MODULES.MANAGE_REPORT_APPROVAL]: {
    acceptedFileTypes: ".pptx, .ppt",
    fileTypeDescription: "PPT files (PPT, PPTX)",
    hintText: "Supported file types: PPT, PPTX",
  },
  [FILE_UPLOAD_MODULES.MISCELLANEOUS_FILES]: {
    acceptedFileTypes:
      ".csv, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel, .pdf",
    fileTypeDescription: "Excel/PDF files (XLSX, CSV, PDF)",
    hintText: "Supported file types: XLSX, CSV, PDF",
  },
  [FILE_UPLOAD_MODULES.MISCELLANEOUS_FILES_POWER]: {
    acceptedFileTypes: ".pdf",
    fileTypeDescription: "PDF files (PDF)",
    hintText: "Supported file types: PDF",
  },
  [FILE_UPLOAD_MODULES.MANAGE_PM_SEND_EMAIL]: {
    acceptedFileTypes:
      ".csv, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel, .pdf",
    fileTypeDescription: "Excel/PDF files (XLSX, CSV, PDF)",
    hintText: "Supported file types: XLSX, CSV, PDF",
  },
  [FILE_UPLOAD_MODULES.MANAGE_SLA_NOTES]: {
    acceptedFileTypes:
      "image/x-png, image/gif, image/jpeg, image/jpg, image/png",
    fileTypeDescription: "Image files (JPG, JPEG, PNG, GIF)",
    hintText: "Supported file types: JPG, JPEG, PNG, GIF",
  },
  [FILE_UPLOAD_MODULES.MANAGE_IMPORT_DIALOG]: {
    acceptedFileTypes:
      "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel",
    fileTypeDescription: "Excel files (XLSX)",
    hintText: "Supported file types: XLSX",
  },
  [FILE_UPLOAD_MODULES.MANAGE_PM_SCHEDULE]: {
    acceptedFileTypes:
      ".csv, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel",
    fileTypeDescription: "Excel files (XLSX, CSV)",
    hintText: "Supported file types: XLSX, CSV",
  },
};
